<template>
  <div v-if="jwtAccessValid()" class="container ml-1">
    <header>
      <b-row>
      <b-col sm="4">
        <h2 class="align-middle">Итоговые показатели</h2>
      </b-col>
      <b-col sm="2">
        <b-button 
        variant="success"
        @click="fetchReportData()">
          Сформировать
        </b-button>
      </b-col>
      </b-row>
      
    
      
    </header>
    <div class="container" style="text-align:left">
    <b-row align-v="center" class="mb-2">
      <b-col sm="1">
        Период
      </b-col>
      <b-col sm="3">
        <b-form-input type="date" v-model="reportDateFrom"></b-form-input>
      </b-col>
      <b-col sm="3">
        <b-form-input type="date" v-model="reportDateTo"></b-form-input>
      </b-col>
    </b-row>
    
    <b-row align-v="center" class="mb-2">
      <b-col sm="1">
        Магазин
      </b-col>
      <b-col sm="6">
        <b-form-select
        v-model="reportShop"
        :options="shopList"
        value-field="id"
        text-field="label">
        </b-form-select>
      </b-col>
    </b-row>
    
    </div>
    <b-overlay
    id="overlay-background"
    :show="false"
    variant="white"
    opacity="0.50"
    blur="2px"
    class="d-inline-block"
    style="float:left">
    <template v-slot:overlay>
      <div></div>
    </template>
    <div >
      <b-table class="report-table list" 
      striped 
      hover
      bordered
      :items="reportDataTotal" 
      :fields="reportFieldsTotal"
      sort-by="date"
      sticky-header1
      responsive="sm">
      </b-table>
    </div>
    </b-overlay>

    <smart-table 
    v-if="false"
    :table-padd="200"
    :sort-by.sync="status.sortBy"
    :sort-asc.sync="status.sortAsc"
    :items="reportData"
    :fields="reportFields"
    :max-width="4000"
    :min-width="4000">
    </smart-table>

  </div>
</template>

<script>
import { HTTP } from '@/script/http-common'
import SmartTable from '@/components/SmartTable.vue'
import ReportMixin from '@/components/ReportMixin.vue'

export default {
  name: 'ReportTotal',
  components: {
    SmartTable,
  },

  mixins: [ReportMixin],

  props: {
  },

  data () {
    return {
      status: {
        sortBy: 'date',
        sortAsc: false,
      },
      reportData: [],
      reportDataTotal: [],
      reportResponse: [],
      reportDateFrom: null,
      reportDateTo: null,
      reportShop: '_ALL_',
      shopList: [
        {
          id: '_ALL_',
          label: 'Все магазины'
        }
      ],
      reportFieldsTotal: [
        {
          key: 'indicator',
          label: 'Показатель',
          sortable: true,
          formatterSort: false,
          isRowHeader: false,
        },
        {
          key: 'value',
          label: 'Значение',
          sortable: true,
          formatterSort: false,
          isRowHeader: false,
        },
      ],
      reportFields: [
        {
          key: 'date'
        },
        {
          key: 'amountDayShift',
          colspanNum: [2],
          colspanLabel: ['Выручка'],
          total: true,
        },
        {
          key: 'amountNightShift',
          total: true,
        },
        {
          key: 'expenditureSalaryDayShift',
          colspanNum: [2],
          colspanLabel: ['ЗП Оклад'],
          total: true,
        },
        {
          key: 'expenditureSalaryNightShift',
          total: true,
        },
        {
          key: 'expenditureSalaryBonusDayShift',
          colspanNum: [2],
          colspanLabel: ['ЗП ежедневная премия'],
          total: true,
        },
        {
          key: 'expenditureSalaryBonusNightShift',
          total: true,
        },
        {
          key: 'expenditureBonusDayShift',
          colspanNum: [2],
          colspanLabel: ['ЗП премия'],
          total: true,
        },
        {
          key: 'expenditureBonusNightShift',
          total: true,
        },
        {
          key: 'expenditureMiscDayShift',
          colspanNum: [2],
          colspanLabel: ['Расходы (прочие)'],
          total: true,
        },
        {
          key: 'expenditureMiscNightShift',
          label: 'Ночь',
          total: true,
        },
        {
          key: 'cashDayShift',
          colspanNum: [2],
          colspanLabel: ['Размен на конец дня'],
          total: true,
        },
        {
          key: 'cashNightShift',
          total: true,
        },
        {
          key: 'safeDayShift',
          colspanNum: [2],
          colspanLabel: ['Сейф на конец дня'],
          total: true,
        },
        {
          key: 'safeNightShift',
          total: true,
        },
        {
          key: 'writeoff',
          label: 'Списание',
          total: true,
        },
        {
          key: 'revaluation',
          label: 'Переоценка',
          total: true,
        },
        {
          key: 'deliveryDayShift',
          colspanNum: [2],
          colspanLabel: ['Доставка'],
          total: true,
        },
        {
          key: 'deliveryNightShift',
          total: true,
        },
        {
          key: 'moveDayShift',
          colspanNum: [2],
          colspanLabel: ['Перемещение'],
          total: true,
        },
        {
          key: 'moveNightShift',
          total: true,
        },
      ]  
    }       
  },
  
  methods: {
    buildReportData(){
      const vm = this
      vm.reportDataTotal = []
      vm.colspanFields(0).slice(1).forEach(field => {
        let value = ('colspanNum' in field) ? vm.colspanSumTotal(field) : vm.colSum(field.key)
        let indicator = ('colspanNum' in field) ? field.colspanLabel[0] : field.label
        vm.reportDataTotal.push({indicator: indicator, value: value}) 
      }) 
    },

    async fetchReportData() {
      const vm = this
      try {
        let response = await HTTP(vm.jwtAccess()).get(`report-finance/?dateFrom=${vm.reportDateFrom}&dateTo=${vm.reportDateTo}&shop=${vm.reportShop}`)
        if (response.status >= 200 && response.status < 300) {
          vm.reportResponse = response.data
          vm.reportData = response.data
          await vm.fetchShopList()
          vm.buildReportData()
        }
      } catch(error) {
        console.log(error)
      }
    },
    
    async fetchShopList() {
      const vm = this
      try {
        let response = await HTTP(vm.jwtAccess()).get(`shop/`)
        if (response.status >= 200 && response.status < 300) {
          vm.shopList = [
            {
              id: '_ALL_',
              label: 'Все'
            }
          ],
          vm.shopList = vm.shopList.concat(response.data)
        }
      } catch(error) {
        console.log(error)
      }
    },

  },

  mounted() {
    const vm = this
    vm.reportDateFrom = (new Date).toISOString().split("T")[0].slice(0, 8) + "01"
    vm.reportDateTo = (new Date).toISOString().split("T")[0]
    vm.fetchShopList()
    vm.fetchReportData()
  },
  
}
</script>

<style scoped>
header {
  text-align: left;
}

.total {
   font-weight: bold;
}

.report-table {
  font-size: 0.9rem
}

th {
  background: white;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
}

</style>